// tslint:disable:max-line-length

import React from 'react';

export const ChartPercentBar = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect y="15" width="16" height="1" />
      <rect width="4" height="14" opacity="0.3" />
      <rect x="6" width="4" height="14" opacity="0.3" />
      <rect x="12" width="4" height="14" opacity="0.3" />
      <rect x="6" y="3" width="4" height="11" />
      <rect y="8" width="4" height="6" />
      <rect x="12" y="5" width="4" height="9" />
    </svg>
  );
};
